import type * as React from 'react';

import { Description, FieldGroup, Label } from '@gitbook/spine-react';

import type { SitesCustomizationPanelProps } from '../../types';
import { HeaderNavigationEditor } from './HeaderNavigationEditor';

/**
 * Panel to configure header links.
 */
export function HeaderNavigationSettings(props: SitesCustomizationPanelProps): React.ReactElement {
    const { site, organizationId, settings, setSettings, siteSpaceIds } = props;

    return (
        <FieldGroup>
            <Label>Navigation</Label>
            <Description>
                To create a navigation menu add an item, sub-links will show in a dropdown for each
                item.
            </Description>
            <HeaderNavigationEditor
                site={site}
                organizationId={organizationId}
                items={settings.header.links}
                onChange={(items) =>
                    setSettings((prev) => ({ ...prev, header: { ...prev.header, links: items } }))
                }
                siteSpaceIds={siteSpaceIds}
            />
        </FieldGroup>
    );
}
